<template>
  <div class="halfpage__wrapper" :class="isSticky ? 'is-sticky' : ''">
    <v-card flat class="grey lighten-4 mx-auto d-flex align-center" width="300" height="600">
      <v-card-text class="text-center text-overline accent--text">HALFPAGE<br><!-- 300 x 600<br> -->{{ adUnitId }}</v-card-text>
    </v-card>
  </div>
</template>

<script>
  export default {
    name: 'Halfpage',

    props: {
      adUnitId: {
        type: String,
        default: 'div-gpt-ad-0000000000000-0'
      },
      isSticky: {
        type: [Boolean, Number],
        default: true
      }
    }
  }
</script>

<style lang="sass" scoped>
  .halfpage__wrapper.is-sticky
    position: -webkit-sticky
    position: sticky
    top: 80px
</style>